<template>
    <div>
        <b-container fluid class="list">
            <b-row class="title" fluid>
                <b-col class="list-title">
                    {{productList.title}}
                </b-col>
                <b-col class="list-redirect" v-if="productList.redirect">
                    <a :href="'/collections/' + productList.redirect.to" onclick="return false">
                        <span  @click="handleClick(productList.redirect.to)">{{productList.redirect.text}}</span>
                    </a>
                </b-col>
            </b-row>
        </b-container>
        <ScrollList :items="productList.items" :cols="3" :control=true class="product-list-container" @click="goToPage">
            <template v-slot:default="{card}">
                <b-card-text class="tag" v-if="card.tags.length > 0">
                    {{card.tags[0].name}}
                </b-card-text>
                <b-card-text>
                    <span class="title">{{card.title +' '}}</span>
                    <span class="label">{{card.label}}</span>
                </b-card-text>
                <b-card-text v-for="(desc, descIndex) in card.desc" :key="descIndex">
                <span class="desc">
                    {{desc.text}}
                </span>
                </b-card-text>
            </template>
        </ScrollList>
    </div>
</template>
<script>
    import ScrollList from './ScrollList'

    export default {
        name: 'products',
        props: {
            productList: Object
        },
        components: {
            ScrollList
        },
        methods: {
            goToPage(slug){
                this.$router.push({
                    path: '/product/' + slug
                })

                document.scrollingElement.scrollTop = 0

                if (this.productList.reload) {
                    location.reload()
                }
            },
            handleClick(slug){
                this.$router.push({
                    path: '/collections/' + slug
                })
                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>

    .en, .cn {
        .product-list-container {
            /deep/ .card {
                .card-text {
                    .title, .label {
                        font-size: 16px !important;
                    }

                    .desc{
                        font-size: 12px !important;
                    }
                }
            }
        }
    }

    .list {
        .title {
            padding-top: 150px !important;
        }
    }

    .product-list-container {
        margin-bottom: 80px;
    }

    .product-list-container /deep/ .list-item{
         .col-3 {
            flex: 0 0 20% !important;
            max-width: 20% !important;
        }
    }
</style>
